:root ._dsp-flex{display:flex;}
:root ._fb-auto{flex-basis:auto;}
:root ._bxs-border-box{box-sizing:border-box;}
:root ._pos-relative{position:relative;}
:root ._minH-0px{min-height:0px;}
:root ._minW-0px{min-width:0px;}
:root ._shrink-0{flex-shrink:0;}
:root ._fd-row{flex-direction:row;}
:root ._pr-t-space-lar102228{padding-right:var(--t-space-larger);}
:root ._pl-t-space-lar102228{padding-left:var(--t-space-larger);}
:root ._pt-t-space-med104641{padding-top:var(--t-space-medium);}
:root ._pb-t-space-med104641{padding-bottom:var(--t-space-medium);}
:root ._gap-t-space-med104641{gap:var(--t-space-medium);}
:root ._items-center{align-items:center;}
:root ._bg-divider{background-color:var(--divider);}
:root ._bg-primary{background-color:var(--primary);}
:root ._items-stretch{align-items:stretch;}
:root ._fd-column{flex-direction:column;}
:root ._width-24px{width:24px;}
:root ._shrink-1{flex-shrink:1;}
:root ._grow-1{flex-grow:1;}